// Varsayılan limit: 10MB (WebSocket tablo yanıtları büyük olabilir)
export const safeParseJson = (raw, maxSize = 10_000_000) => {
  if (typeof raw !== 'string') {
    return { ok: false, value: null, error: 'non-string' };
  }
  if (raw.length > maxSize) {
    console.error(
      `[safeParseJson] size-limit aşıldı: mesaj boyutu ${raw.length} karakter, limit ${maxSize} karakter.`,
      'İlk 200 karakter:', raw.slice(0, 200)
    );
    return { ok: false, value: null, error: 'size-limit' };
  }
  try {
    return { ok: true, value: JSON.parse(raw), error: null };
  } catch (error) {
    return { ok: false, value: null, error: 'parse-error' };
  }
};
